<div id="topScrollY" class="content-container d-flex flex-column">

  <div id="top_header" class="sticky-top header_content bg-white">
    <a [ngClass]="scrollDirection == 'down' || isMapToggle ? 'h-0' :''"
      class="d-block d-lg-none w-100 text-center overflow-hidden"
      href="/" *ngIf="innerWidth <= 991">
      <img alt="Logo LivinFrance" loading="lazy"
        sizes="(max-width: 479px) 66vw, 148px"
        src="/assets/img/seoHeaderImg/LF_logo-horizontal.webp"
        srcset="/assets/img/seoHeaderImg/LF_logo-horizontal-p-500.png 500w, /assets/img/seoHeaderImg/LF_logo-horizontal-p-800.png 800w, /assets/img/seoHeaderImg/LF_logo-horizontal-p-1080.png 1080w, /assets/img/seoHeaderImg/LF_logo-horizontal-p-1600.png 1600w,src\assets\img\seoHeaderImg /assets/img/seoHeaderImg/LF_logo-horizontal-p-2000.png 2000w, /assets/img/seoHeaderImg/LF_logo-horizontal.webp 2389w">
    </a>

    <div class="d-flex gap-2 gap-lg-4 py-3 py-lg-4 border-bottom border-lightGray">
      <ng-container *ngIf="!loading else filterLoadingTemplate">
        <app-accommodation-city-input class="col-10 col-lg-5 flex-grow-1 flex-lg-grow-0"
          [showMatChip]="searchFrom === 'searchbar'" [searchElement]="searchFrom === 'searchbar' ? searchElement : null"
          (hasChangedCity)="trigChangeCity($event); searchFrom='searchbar'"
          (hasSearched)="doSearch($event)" [currentSearchResult]="search"></app-accommodation-city-input>

        <app-component-filter-modal (filteredRooms)="filteredRooms($event)" [favList]="favList"
          (filterObj)="getFilters($event)"
          [rooms]="allRooms" [searchCity]="searchElement"></app-component-filter-modal>

        <div class="text_4 border-start ps-4 align-self-auto align-content-around border-lightGray" *ngIf="isMapOnly">
          {{ (rooms ? rooms.length : 0) + " " }}
          <span *ngIf="countProperties && rooms.length > 0 && rooms.length !== countProperties" class="text_1">
              ({{countProperties}})
            </span>
          {{" " + ("PROCESSES.ACCOMMODATION.LIST.NB_ROOMS" | translate)}}
        </div>
      </ng-container>

      <ng-template #filterLoadingTemplate>
        <app-accom-filter-ph class="w-100"></app-accom-filter-ph>
      </ng-template>
    </div>
  </div>

  <div class="d-flex flex-column flex-lg-row flex-grow-1 position-relative align-items-start">

    <!-- -------------------------------- LEFT PART - ROOM LIST  -------------------------------- -->
    <div id="list-left" class="col-12 col-lg-6 m-0 p-0 flex-grow-1 left_content bg-white" *ngIf="!isMapOnly || isMapToggle">

      <!--   sticky sub header   -->
      <div class="position-sticky LC-sticky bg-white" [style.top]="scrollDirection === 'top' ? (headerHeight + 'px') : '-10rem'">
        <div class="border-bottom border-lightGray mb-4 d-flex flex-row justify-content-between pb-3 pt-2 pt-lg-4 align-items-center gap-2">

          <ng-container *ngIf="!loading else subHeaderLoadingTemplate">
            <div class="text_4 d-flex flex-row gap-1">
            <span>
              {{ (rooms ? rooms.length : 0) + " " }}
            </span>
              <span *ngIf="countProperties && rooms.length > 0 && rooms.length !== countProperties" class="text_1">
              ({{countProperties}})
            </span>
              <ng-container *ngIf="searchFrom === 'map' || search">
                {{" "}}
                {{ ('PROCESSES.ACCOMMODATION.LIST.NB_ROOMS_' +
                (searchFrom === 'map' ? 'IN_SEARCHZONE' : (search.type === 'school' ? 'AROUND_SCHOOL' : 'IN_CITY'))
              ) | translate:{city: search?.name, school: search?.name} }}
              </ng-container>
            </div>

            <mat-select panelClass="left-margin" *ngIf="innerWidth >= 991" [(ngModel)]="sort" (ngModelChange)="doSort($event)" [ngClass]="{'isSelected': sort && sort !== 'none'}"
              class="d-none d-lg-block w-auto border-0 bg-transparent txt-darkGray minitext_1">
              <mat-option class="minitext_1" [value]="sort.value" *ngFor="let sort of sortList;trackBy:sortTrackBy">
                {{ ('PROCESSES.ACCOMMODATION.LIST.' + sort.key) | translate }}
              </mat-option>
            </mat-select>
          </ng-container>
          <app-expand-button *ngIf="innerWidth <= 991" class="d-block d-lg-none" (toggleValue)="toggleMenu($event)"
            icon1="GradientFourBlock" icon2="GradientMapIcon" icon3="mapIcon" icon4="fourBlock"
            mode="toggle"></app-expand-button>

          <ng-template #subHeaderLoadingTemplate>
            <app-accom-nb-and-sort-ph class="w-100"></app-accom-nb-and-sort-ph>
          </ng-template>
        </div>
      </div>


      <!--   liste des chambres   -->
      <ng-container *ngIf="!isMapToggle">
        <div class="d-flex flex-wrap my-3 room-list w-100" *ngIf="!loading else roomListLoadingTemplate">

          <ng-container *ngFor="let room of displayedRooms; let index = index;trackBy:propertyTrackBy">
            <app-accommodation-room-card (click)="goToRoom(room); clickMarker(room.id, false)"
              (focusin)="addClassToMarker('active',room.id); checkItem(room.id)"
              (focusout)="checkItem(room.id);currentDisplayedMarker = null;"
              (keypress.enter)="goToRoom(room); clickMarker(room.id, false)"
              (mouseenter)="addClassToMarker('active',room.id);checkItem(room.id)"
              (mouseleave)="checkItem(room.id);currentDisplayedMarker = null;removeClass(room.id, 'active')"
              [favList]="favList" [room]="room" (changedFavorite)="changeFavorite($event)"
              class="room-component pointer"
              id="room_{{room.id}}"></app-accommodation-room-card>
            <app-accommodation-alerts *ngIf="index == (innerWidth < 1600 ? 19 : 20) && loadedOnce" [filters]="filterFormModale"
              class="w-100"></app-accommodation-alerts>
            <div class="d-flex flex-row align-items-center justify-content-between justify-content-sm-around w-100 bg-grey py-3 px-3 px-sm-5 br-10 gap-2" *ngIf="index == (innerWidth < 1600 ? 3 : 5)">
              <app-lf-advantages [text]="'ROOM.ADVANTAGES.ROOM_VERIFIED'" [iconName]="'livinProtect'" [title]="'ROOM.ADVANTAGES.ROOM_VERIFIED_TITLE'"></app-lf-advantages>
              <app-lf-advantages [text]="'ROOM.ADVANTAGES.GUARANTOR'" [iconName]="'livinGarantGray'" [title]="'ROOM.ADVANTAGES.GUARANTOR_TITLE'"></app-lf-advantages>
            </div>
          </ng-container>

          <div class="d-flex align-items-center justify-content-center gap-3 w-100 mb-5 pb-5" *ngIf="displayedRooms && displayedRooms.length > 0">
            <button class="btn btn-lf-secondary d-flex gap-2 border-0" type="button" role="button" (click)="fetchMoreRooms('previous')"
              [disabled]="!displayedRooms || displayedRooms[0].id === rooms[0].id">
              <lf-icon name="leftArrow" height="16px" width="16px"></lf-icon>
              {{ 'COMMON.PREVIOUS' | translate }}
            </button>
            <button class="btn btn-lf-secondary d-flex gap-2 border-0" type="button" role="button" (click)="fetchMoreRooms('next')"
              [disabled]="!displayedRooms || displayedRooms[displayedRooms.length - 1].id === rooms[rooms.length - 1].id">
              {{ 'COMMON.NEXT' | translate }}
              <lf-icon name="arrow" height="16px" width="16px"></lf-icon>
            </button>
          </div>

          <ng-container *ngIf="noFilteredRooms && noFilteredRooms.length > 0">
            <h3 class="w-100 title_2 border-top pt-5 mt-4 mt-sm-0 pt-sm-3">{{ 'PROCESSES.ACCOMMODATION.MIGHT_INTEREST_ROOMS' | translate }}</h3>
            <ng-container *ngFor="let room of noFilteredRooms; let index = index;trackBy:propertyTrackBy">
              <app-accommodation-room-card (click)="goToRoom(room); clickMarker(room.id, false)"
                (focusin)="addClassToMarker('active',room.id); checkItem(room.id)" (changedFavorite)="changeFavorite($event)"
                (focusout)="checkItem(room.id);currentDisplayedMarker = null;"
                (keypress.enter)="goToRoom(room); clickMarker(room.id, false)"
                (mouseenter)="addClassToMarker('active',room.id);checkItem(room.id)"
                (mouseleave)="checkItem(room.id);currentDisplayedMarker = null;removeClass(room.id, 'active')"
                [favList]="favList" [room]="room" [typeCard]="'filterProposal'" [filter]="filterFormModale"
                class="room-component"
                id="room_{{room.id}}"></app-accommodation-room-card>
            </ng-container>
          </ng-container>
        </div>

        <ng-template #roomListLoadingTemplate>
          <app-accommodation-list-ph></app-accommodation-list-ph>
        </ng-template>
      </ng-container>


    </div>

    <!-- -------------------------------- RIGHT PART - MAP --------------------------------  -->
    <div class="col-12 right_content" [ngClass]="[isMapOnly ? 'col-lg-12' : 'col-lg-5', isMapToggle ? 'show' : 'hide']">

      <!--   Button expand map/ afficher la liste   -->
      <app-expand-button *ngIf="innerWidth >= 991" class="d-none d-lg-block position-absolute btn-option-start"
        (toggleValue)="desktopMapConfig($event)"
        [icon1]="'rightChevron'" [icon2]="'mapIcon'" [icon3]="'fourBlock'"
        [text1]="'BUTTON.EXPAND.MAP_SEARCH'"
        [text2]="'BUTTON.EXPAND.LIST_SEARCH'"></app-expand-button>

      <!--   Boutons relancer la recherche ici & recherche par la map   -->
      <div class="searchMapBtn pointer absolute-inline-centered">
        <label for="searchOnMove" class="bg-white p-2 d-flex align-items-center justify-content-center gap-3 text_2 transition025 pointer"
          *ngIf="(!isSearchOnMove && !isMove) || (isSearchOnMove)">
          <input id="searchOnMove" type="checkbox" class="border-0 bg-white txt-darkGray minitext_1"
            [(ngModel)]="isSearchOnMove"/>
          {{ 'PROCESSES.ACCOMMODATION.MAP.SEARCH_ACCOMMODATION' | translate }}
        </label>

        <label for="updateSearchOnMove" class="bg-white p-2 d-flex align-items-center justify-content-center gap-3 text_2 transition025 pointer"
          *ngIf="(!isSearchOnMove && isMove)" (click)="reloadSearchOnMap()">
          <lf-icon id="updateSearchOnMove" name="reloadArrow" class="d-flex justify-content-center" fillColor="black" height="14px" width="14px"></lf-icon>
          {{ 'PROCESSES.ACCOMMODATION.MAP.RESTART_SEARCH' | translate }}
        </label>
      </div>

      <!--   Contenant de la map -->
      <div class="map" id="map"></div>

      <!--   Description des chambres - au clic sur les pastilles   -->
      <app-accommodation-map-card (click)="goToRoom(activeCard)" *ngIf="activeCard"
        (closeCard)="unactiveCard($event)" (changedFavorite)="changeFavorite($event)"
        [favList]="favList" [forceUpdate]="true"
        [room]="activeCard"></app-accommodation-map-card>

    </div>

  </div>

</div>
